import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.Contact = {
  displayName: 'Contact',
  contactPreferenceMinimumQuotes: 6,
  setPhoneError: function() {},

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    let phoneNumberGroup      = $('.phone-number-group')
    let phoneNumberVisible    = phoneNumberGroup.is(':visible')
    let phoneNumber           = phoneNumberGroup.find('.js-phone-number').val()
    let userId                = SS.currentUserId

    if (this.contactByPhone() && phoneNumberVisible) {
      let validationUrl = Job.Data.phoneVerificationRequired ? '/users/validate_mobile_contact_phone' : '/users/validate_contact_phone'

      Job.Actions.updatePhoneNumber(phoneNumber)
      onRequest()

      let onContactStepComplete = () => {
        SS.userPhoneIsValid = true
        SS.userPhoneVerified = false

        if (Job.Data.phoneNumberEditRequested) {
          Job.Actions.updatePhoneNumberEditRequested(false)
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.VerifyNumber)
          return
        }

        onStepProgression()
      }

      $.ajax({
        url: validationUrl,
        dataType: 'json',
        data: { user_attributes: { contact_phone: phoneNumber } }
      }).done((result) => {
        if (!result.valid) {
          JobWizard.Contact.setPhoneError('Invalid Mobile Number')
          onRequestCompletion()
          return
        }

        var sessionObj = SS.API.V3.userUpdate({
          'contact-phone': phoneNumber
        }, userId, { forcePhoneVerificationReset: true })

        $.ajax(sessionObj)
         .always(onRequestCompletion)
         .fail(() => {
            JobWizard.Contact.setPhoneError('Invalid Mobile Number')
         })
         .done(onContactStepComplete)
      }).fail(() => {
        onRequestCompletion()
        document.location = "/500"
      })
    }
    else {
      onStepProgression()
    }
  },

  contactByPhone: function() {
    return Job.Data.canCall
  },

  component: React.createClass({
    job: Job,

    getInitialState: function() {
      return {
        isPhoneNumberHidden: true,
        loading: true,
        phoneNumberHasError: false
      }
    },

    componentDidMount: function() {
      JobWizard.Contact.setPhoneError = this.setPhoneNumberError.bind(this)
      Job.Actions.updateContactOptions(true)
      this.getContactPhone()
    },

    handlePhoneNumberChange: function(e) {
      Job.Actions.updatePhoneNumber(e.target.value)
    },

    handlePhoneNumberBlur: function() {
      this.setState({ phoneNumberHasError: false })

      if (this.props.onPhoneErrorChange) {
        this.props.onPhoneErrorChange('')
      }
    },

    setPhoneNumberError: function(message) {
      this.setState({ phoneNumberHasError: true })

      if (this.props.onPhoneErrorChange) {
        this.props.onPhoneErrorChange(message)
      }
    },

    getContactPhone: function(){
      let userId = SS.currentUserId

      var sessionObj = SS.API.V3.userGet({
        id: userId
      })

      $.ajax(sessionObj)
      .always(() => {
        this.setState({ loading: false })
      })
      .fail(function() {
        document.location = "/500"
      })
      .done((response) => {
        let attributes = response.data.attributes || {}
        let hasValidPhone = response.meta.validPhone === true
        let hasVerifiedPhone = attributes.user_verified === true || attributes.userVerified === true || attributes['user-verified'] === true
        let phoneNumber = hasValidPhone ? (attributes.phone || '') : ''

        Job.Actions.updatePhoneNumber(phoneNumber)
        SS.userPhoneIsValid = hasValidPhone
        SS.userPhoneVerified = hasVerifiedPhone
        this.setState({ isPhoneNumberHidden: Job.Data.phoneNumberEditRequested ? false : hasValidPhone })

        if (hasValidPhone && !Job.Data.phoneNumberEditRequested) {
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.VerifyNumber)
        }
      })
    },

    render: function() {
      return (
        <div className="form-group">
          {
            !Job.Data.exclusiveFor ?
              <div>
                <div className={`${this.state.loading ? '' : 'hidden'}`}>
                  <div className="modal-body job-form-body radius-16-bottom">
                    <div className="spinner-icon text-center"/>
                  </div>
                </div>
                <div className={`${this.state.loading ? 'hidden' : ''}`}>
                  <div className={`phone-number-group phone-number-step ${this.state.isPhoneNumberHidden ? 'hidden' : 'active'}`}>
                    <div className="row pl24 pr24 pt16 pb0">
                      <div className="col-sm-12 col-xs-12 mt0 mb0 pl0 pr0">
                        <div className="text-center font-21 bold">
                          Please enter your mobile number
                        </div>
                        <div className="text-center font-14 mt8">
                          The businesses will use this to contact you about your enquiry.
                        </div>
                        <div className="row mt24 mb8 col-md-10 col-centered pl0 pr0 sm-pl16 sm-pr16">
                          <div className={`col-sm-12 col-xs-12 ${this.state.phoneNumberHasError ? 'has-error' : ''}`}>
                            <input
                              name="phone-number"
                              type="text"
                              className="form-control js-phone-number text-center"
                              maxLength="30"
                              size="30"
                              defaultValue={''}
                              placeholder="04XXXXXXXX"
                              onBlur={this.handlePhoneNumberBlur}
                              onChange={this.handlePhoneNumberChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-xs-12 mt8 mb0 text-center phone-number-helper">
                          Please enter a valid Australian mobile number (e.g. 0412345678)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            :
            <JobWizard.ExclusiveJob.ContactDetails
              loading={this.state.loading}
              handlePhoneNumberChange={this.handlePhoneNumberChange}
            />
          }
        </div>
      )
    }
  })
}
